export default [
  {
    name: "getCouponProductList",
    method: "post",
    desc: "优惠劵列表",
    path: "/obt/coupon/getCouponProduct",
    params: {
      corpId: ""
    }
  },
  {
    name: "drawCoupon",
    method: "post",
    desc: "领取优惠劵",
    path: "/obt/coupon/drawCoupon",
    params: {
      id: ""
    }
  },
  {
    name: "getCouponProduct",
    method: "post",
    desc: "我的优惠劵列表",
    path: "/obt/coupon/getCouponProduct",
    params: {
      corpId: "",
      code: ""
    }
  }
];
